import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { EVENT_NAMES, PARAM_KEYS, trackEvent } from "../analytics";
import { useBrand } from "../branding/BrandContext";
import {
  getCrossSiteProjectsForBrand,
  getOppositeBrandKey,
} from "../config/projects";
import { getPreferredCategoryPath } from "../utils/locationStorage";

const CROSS_SITE_BASE_URLS = {
  "home-helper": "https://home-helper.com",
  "house-helper": "https://house-helper.com",
};

function CrossSiteProjectSelector() {
  const brand = useBrand();
  const brandKey = brand?.brandKey || "home-helper";
  const targetBrandKey = getOppositeBrandKey(brandKey);
  const targetBaseUrl = CROSS_SITE_BASE_URLS[targetBrandKey];
  const projects = getCrossSiteProjectsForBrand(brandKey);
  const targetBrandName =
    targetBrandKey === "house-helper" ? "House-Helper" : "Home-Helper";
  const targetProjectType =
    targetBrandKey === "house-helper" ? "outdoor" : "indoor";
  const mascotSrc =
    targetBrandKey === "house-helper"
      ? "/assets/house-helper-mascots.png"
      : "/assets/home-helper-mascots.png";
  const prompt =
    brandKey === "house-helper"
      ? "Do you have an indoor project?"
      : "Do you have an outdoor project?";

  if (!targetBaseUrl || projects.length === 0) {
    return null;
  }

  const handleCardClick = () => {
    trackEvent(EVENT_NAMES.CTA_CLICK, {
      [PARAM_KEYS.CTA_NAME]: "cross_site_homepage_clicked",
      [PARAM_KEYS.PLACEMENT]: "home_sidebar_cross_site",
      source_brand: brandKey,
      destination_brand: targetBrandKey,
    });

    window.location.href = targetBaseUrl;
  };

  const handleCardKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleCardClick();
    }
  };

  const handleChange = (event) => {
    const slug = event.target.value;
    const selectedProject = projects.find((project) => project.slug === slug);

    if (!slug || !selectedProject) {
      return;
    }

    trackEvent(EVENT_NAMES.CTA_CLICK, {
      [PARAM_KEYS.CTA_NAME]: "cross_site_project_selected",
      [PARAM_KEYS.CATEGORY_KEY]: slug,
      [PARAM_KEYS.PLACEMENT]: "home_sidebar_cross_site",
      source_brand: brandKey,
      destination_brand: targetBrandKey,
    });

    window.location.href = `${targetBaseUrl}${getPreferredCategoryPath(slug)}`;
  };

  return (
    <div
      className={`crossSiteProjectSelector crossSiteProjectSelector--${targetBrandKey}`}
      role="link"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
    >
      <img
        src={mascotSrc}
        alt=""
        className="crossSiteProjectSelectorMascot"
        draggable="false"
        aria-hidden="true"
      />
      <div className="crossSiteProjectSelectorContent">
        <span className="crossSiteProjectSelectorEyebrow">
          Explore {targetBrandName}
        </span>
        <label
          htmlFor="cross-site-project-select"
          className="crossSiteProjectSelectorLabel"
        >
          {prompt}
        </label>
        <p className="crossSiteProjectSelectorCopy">
          Jump to {targetProjectType} project estimates and local contractor matches.
        </p>
      </div>
      <select
        id="cross-site-project-select"
        className="crossSiteProjectSelectorSelect"
        defaultValue=""
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
        onChange={handleChange}
      >
        <option value="" disabled>
          Select project
        </option>
        {projects.map((project) => (
          <option key={project.key} value={project.slug}>
            {project.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function ServiceProviderCTA() {
  const navigate = useNavigate();
  const [zip, setZip] = useState("");
  const [category, setCategory] = useState("");

  const handleSearch = () => {
    if (!zip) return;

    trackEvent(EVENT_NAMES.BROWSE_PROVIDERS_CLICK, {
      [PARAM_KEYS.ZIP_CODE]: zip.trim(),
      [PARAM_KEYS.PLACEMENT]: "home_sidebar",
    });

    navigate(`/providers?zip=${zip}`);
  };

  return (
    <div>
      <CrossSiteProjectSelector />

      <div className="propertyReportCTA">
        <Link to="/tools/property-report" className="homeReportCta">
          <img
            src="/assets/home-report-cta-1.png"
            alt="Get a free home property report"
            className="homeReportCtaImage"
            draggable="false"
          />
        </Link>
      </div>
      <div className="browseProvidersCTA">
        
        <h3 className="browseProvidersHeader">
          Browse Service Providers
        </h3>

        <p className="browseProvidersbyline">
          Find trusted local<br />professionals in your area
        </p>

        <input
          type="text"
          placeholder="Enter ZIP code"
          value={zip}
          onChange={(e) => setZip(e.target.value)}
          className="browseProvidersInput"
        />
  <br />
        
        <button
          onClick={handleSearch}
          className="browseProvidersBtn"
        >
          Find Providers
        </button>
      </div>
    </div>
  );
}
